export const TESTS = [
  {
    'page': 1,
    'title': `<h4>Part 1</h4>
    <p>Read the text below and answer questions <b>1</b> – <b>4</b>.</p>`,
    'question': {
      'title': `Political units in the history of West Africa`,
      'content': `<p style="margin: 25px 0;"><i style="font-size:16px;font-weight:520">Note: this is an extract from a General Training Reading text on the subject of political units in the history of West Africa</i></p>
      <p>Some of Africa’s earliest substantial masonry structures outside Egypt were built in West Africa. The fact that they were constructed demonstrates the existence of a sedentary and complex political unit. At Dhar Tichitt and Dhar Oualata, in modern Mauritania, a new chiefdom developed (around 2000–800 BC) in a deteriorating environment where arable land and pasturage for animals were at a premium. A four-tier settlement hierarchy has been discovered (that is, towns and other settlements at four levels of importance, based on size, function, and type of building), with the largest regional centers exceeding 220 acres (90 ha) in area. The evolution of Tichitt-Oualata society remains unclear, obscured by the poor condition of settlement sites. Competing hypotheses include long-term development in the area, rapid evolution, or immigration from elsewhere. Evidence points to the importance of mixed farming – both crops and animals. Inorganic wealth lay in beads, bracelets and small stone axes. Unfortunately, none of the region’s many tumuli* have yet been excavated. It would appear that the collapse of Tichitt-Oualata around 800 BC was brought about both by the increasing drying of the earth in the region and growing harassment from interlopers from outside.</p>
      <p>During the first millennium BC, the advent of metallurgy added further impetus to the growth of complex societies south of the Sahara Desert. Indeed, precious metals were to play a key role in international trade between West Africa and the Mediterranean world, and between East Africa and Asia, throughout the late first and early second millennia AD. At a regional level, iron and copper were crucial materials for making both practical and prestige objects. Coupled with trade in ivory, the control of metallurgical commodities supplanted subsistence farming as the power basis of African elites from the beginning of the first millennium AD.</p>
      <p>The empire of Ghana existed before Arab geographers began to write of West Africa in the eighth century AD. Its origins and extent remain unclear. The ruins of one of its capitals, Kumbi-Saleh, lie in southeastern Mauritania; yet the most substantive settlement clusters known from the first millennium AD rest within the bounds of the Middle Niger river in neighboring Mali. Earlier scholarly thought placed Ghana as a state founded by Arab traders from North Africa, but recent research has emphasized the indigenous development of regional trade webs long before the Arab conquest of North Africa around AD 750. </p>
      <p>Undoubtedly, the Middle Niger’s best-excavated site is that of Jenné-Jeno (250 BC to AD 1400). Here, trade with adjoining regions in commodities such as copper, iron, and sandstone is in evidence by AD 500. Additionally, by AD 800, local craft specialization and a regional hierarchy centered on Jenné-Jeno point to an urban status for the site. However, Jenné-Jeno is only one of many impressive settlements now known from the Middle Niger. The occupation of such sites continued through the time of Ghana's Islamic successor states, the empire of Mali (AD 1250–1600) and the empire of Songhai (AD 1375–1600). Future work is likely to confirm the view that the heart of the empire of Ghana, like that of the Malinke empire of Mali, lay not in its trade centers in the Sahara but closer to the resource centers of the Middle Niger.</p>
      <p>While Jenné-Jeno was flourishing, spectacular developments were also taking place in the West African forest. Although limited excavations have only begun to hint at the political organization of Nigerian societies during the late first millennium AD, their richness and artistic expertise have been well demonstrated at the site of Igbo-Ukwu. Here an elaborate burial and a storehouse of regalia have been excavated, both holding superb brass castings and thousands of glass beads. The presence of such wealth hints at a well-organized system of trade, remarkably accomplished craft specialists, and a wealthy elite, but we know little of settlements in the region until the emergence of the state of Ife around AD 1100.</p>
      <br/><br/><br/>
      <p>*<i>tumuli: small burial mounds made of stone and earth</i></p>
      `
    },
    'answer': {
      'type': 'table inputs two',
      'question': 'Questions 1 – 4',
      'number': 4,
      'description': 'Choose the correct political unit <b>(A – C)</b>. for each statement. You may choose any political unit more than once.',
      'title': '',
      'className': 'table-inputs-two',
      'content': [
        {
          'id': 1,
          'answers': 'There is evidence that metal workers were highly skilled.'
        },
        {
          'id': 2,
          'answers': 'No investigation of certain structures has taken place.'
        },
        {
          'id': 3,
          'answers': 'Habitation continued after the decline of the political unit.'
        },
        {
          'id': 4,
          'answers': 'Different residential areas had different characteristics.'
        }
      ],
      answersIndex: ['A', 'B', 'C'],
    }
  },
  {
    'page': 2,
    'title': `<h4>Part 1</h4>
    <p>Read the texts and answer questions <b>5</b> – <b>10</b>.</p>`,
    'question': {
      'title': `For Rent`,
      'content': `<h2>A</h2>
      <div>
        <p><b>Westwood Towers</b> in desired northwest location. Brand new 2-bedroom units.</p>
        <ul>
          <li>Open concept living</li>
          <li>City views</li>
          <li>Climate control in each unit</li>
          <li>Storage lockers available</li>
          <li>Underground parking</li>
          <li>$799 + utilities</li>
        </ul>
        <p>Model suite open weekends. </p>
        <p>For information call 1632 41-1539</p>
      </div>
      <h2>B</h2>
      <div>
        <p><b>GREAT VALUE</b> 1-bedroom units. Enjoy the convenience of living just steps away from stores and services.</p>
        <ul>
          <li>On-site laundry</li>
          <li>Underground parking</li>
          <li>Gym on lower level</li>
          <li>Singles and couples preferred</li>
          <li>$700 per month plus heat. One year lease and references required. </li>
        </ul>
        <p>Rental Office open daily 9 – 9.  </p>
        <p>495 Colborne St 1632 523-2222</p>
      </div>
      <h2>C</h2>
      <div>
        <p><b>WELL-KEPT</b> 1- and 2-bedroom units in older high-rise building.</p>
        <ul>
          <li>Very spacious units</li>
          <li>No pets</li>
          <li>Olympic-sized pool behind building</li>
          <li>Laundry on premises</li>
          <li>Gas heat</li>
          <li>On bus route </li>
        </ul>
        <p>References needed. Ready for occupancy. Contact Z Group Realty 1632 521-4123 www.zgroup.com</p>
      </div>
      <h2>D</h2>
      <div>
        <p><b>1092 WONDERLAND RD.</b></p>
        <p>Now accepting applications for 1-, 2-, & 3-bedroom units. </p>
        <ul>
          <li>Prime location in the west</li>
          <li>Key-card entry</li>
          <li>Free indoor parking with 2yr lease</li>
          <li>Laundry facilities on-site</li>
          <li>En-suite bath</li>
        </ul>
        <p>$725 incl. hydro. Heat extra. Call to view. Baseline Holdings 1632 525-7835</p>
      </div>
      <h2>E</h2>
      <div>
        <p><b>GROUND FLOOR</b> Two-bedroom units for rent. </p>
        <ul>
          <li>Master bedroom with en-suite bath</li>
          <li>Enclosed patio at the back</li>
          <li>Alarm system</li>
          <li>Electric heat</li>
          <li>Parking at the front of each unit</li>
          <li>Washer/dryer in suite</li>
          <li>Bus at the door</li>
        </ul>
        <p>Perfect for adult lifestyle. Rent includes membership to a nearby community centre with pool and fitness </p>
        <p>machines. $800 + heat & hydro. Londor Realty 1632 776-9054 or www.linodours.com</p>
      </div>
      <h2>F</h2>
      <div>
        <p><b>NEW HIGH RISE COMPLEX</b> inviting applications. 1-, 2- & 3-bedroom units.  </p>
        <ul>
          <li>Eat-in kitchen with dishwasher</li>
          <li>Panoramic views from living room</li>
          <li>Luxurious main bath with whirlpool tub</li>
          <li>2-vehicle underground parking</li>
          <li>Lower level has laundry and common room</li>
        </ul>
        <p style="text-align:center">$975 all inclusive </p>
        <p style="text-align:center">View by appointment.</p>
        <p style="text-align:center">Sentry Apts. 1632 503-9762</p>
      </div>
      `
    },
    'answer': {
      'type': 'table inputs',
      'question': 'Questions 5 – 10',
      'number': 6,
      'description': `Look at the six rental notices (<b>A</b> – <b>F</b>). For which rental unit are the following statements true? <br/>
      Choose the correct letter (<b>A</b> – <b>F</b>).<br/>
      You may choose any letter more than once.`,
      'title': '',
      'className': 'table-inputs',
      'content': [
        {
          'id': 5,
          'answers': 'The unit has a private outdoor space.'
        },
        {
          'id': 6,
          'answers': 'The unit is available immediately.'
        },
        {
          'id': 7,
          'answers': 'There is exercise equipment on-site.'
        },
        {
          'id': 8,
          'answers': 'The unit is a generous size.'
        },
        {
          'id': 9,
          'answers': 'Entrance to the building is restricted.'
        },
        {
          'id': 10,
          'answers': 'The unit is close to shopping.'
        }
      ],
      answersIndex: ['A', 'B', 'C', 'D', 'E', 'F'],
    }
  },
  {
    'page': 3,
    'title': `<h4>Part 1</h4>
    <p>Read the text below and answer questions <b>11</b> – <b>16</b>.</p>`,
    'question': {
      'title': '',
      'content': `<h1 style="font-size:24px">Railway Season Tickets</h1>
      <h4 style="font-size:16px">Types of Season Tickets</h4>
      <p>Standard season tickets allow unlimited travel between the two train stations shown on the ticket for the full duration of their validity. You can break your journey at any train station between the origin and destination station on your season ticket.</p>
      <p>Combined rail-and-bus season tickets are available from some rail stations. This means if you can make your main journey by rail, you can then complete it by bus. Two separate season tickets may be required for some destinations.</p>
      <br/>
      <h4 style="font-size:16px">Ticket Duration</h4>
      <p><b>7-day</b><br/>
      These normally cost less than five standard day-returns. They are valid for a full seven days’ rail travel between the points shown on the train ticket.</p>
      <p><b>Monthly</b><br/>
       Monthly season tickets are priced at less than four times the cost of 7-day train tickets and are valid for a full calendar month from the date of commencement.</p>
      <p><b>Annual Card</b><br/>
       This gives you a full calendar year's weekday travel for the price of only 40 weekly tickets.
       Annual Card holders can also save a third on the price of most Standard Class train fares in the region at weekends and on Bank Holidays.
       You can also take up to three adults with you at the same discount, while up to four children (aged 5–15) may accompany you for a minimum of £1 each. </p>
      <p><b>How do I buy my first season ticket?</b><br/>
      Your season ticket is not valid without a photocard, and both must always be carried together. A photocard will be issued to you free of charge when you first purchase a season ticket.
      You just need to take a passport-sized photograph to a ticket office and we'll do the rest. As long as your photo remains a good likeness,
      you can continue to use the photocard with any subsequent season tickets that you buy.</p>
      `
    },
    'answer': {
      'type': 'radios',
      'question': 'Questions 11 – 16',
      'number': 6,
      'description': 'Choose <b>TRUE</b> if the statement agrees with the information given in the text, choose <b>FALSE</b> if the statement contradicts the information, or choose <b>NOT GIVEN</b> if there is no information on this.',
      'title': '',
      'content': [
        {
          'id': 11,
          'question': '<b>11</b>You are allowed to stop off at an intermediate station when making a journey using a standard season ticket.',
          'answers': [
            {'id': 1, 'content': 'TRUE'},
            {'id': 2, 'content': 'FALSE'},
            {'id': 3, 'content': 'NOT GIVEN'}
          ]
        },
        {
          'id': 12,
          'question': '<b>12</b>When using a combined rail-and-bus season ticket, the major part of your journey must be by train.',
          'answers': [
            {'id': 1, 'content': 'TRUE'},
            {'id': 2, 'content': 'FALSE'},
            {'id': 3, 'content': 'NOT GIVEN'}
          ]
        },
        {
          'id': 13,
          'question': "<b>13</b>It is more expensive to buy four 7-day tickets than a monthly season ticket for the same journey.",
          'answers': [
            {'id': 1, 'content': 'TRUE'},
            {'id': 2, 'content': 'FALSE'},
            {'id': 3, 'content': 'NOT GIVEN'}
          ]
        },
        {
          'id': 14,
          'question': '<b>14</b>Annual Card season tickets entitle you to savings on other rail journeys outside of the working week.',
          'answers': [
            {'id': 1, 'content': 'TRUE'},
            {'id': 2, 'content': 'FALSE'},
            {'id': 3, 'content': 'NOT GIVEN'}
          ]
        },
        {
          'id': 15,
          'question': '<b>15</b>Children under the age of five are charged one third of the full ticket price when accompanying you on an Annual Card journey.',
          'answers': [
            {'id': 1, 'content': 'TRUE'},
            {'id': 2, 'content': 'FALSE'},
            {'id': 3, 'content': 'NOT GIVEN'}
          ]
        },
        {
          'id': 16,
          'question': "<b>16</b>The photo you supply at the time of application is displayed on your season ticket.",
          'answers': [
            {'id': 1, 'content': 'TRUE'},
            {'id': 2, 'content': 'FALSE'},
            {'id': 3, 'content': 'NOT GIVEN'}
          ]
        }
      ]
    }
  },
  {
    'page': 4,
    'title': `<h4>Part 1</h4>
    <p>Read the text below and answer questions <b>17</b> – <b>18</b>.</p>`,
    'question': {
      'title': 'The History of Early Cinema',
      'content': `<p style="margin: 25px 0;"><i style="font-size:16px;font-weight:520">Note: this is an extract from a General Training Reading text on the subject of the history of early cinema.</i></p>
      <p>In the end it was the United States that was to become, and remain, the largest single market for films. By protecting their own market and pursuing a vigorous export policy, the Americans achieved a dominant position on the world market by the start of the First World War. The centre of film-making had moved westwards, to Hollywood, and it was films from these new Hollywood studios that flooded onto the world’s film markets in the years after the First World War, and have done so ever since. Faced with total Hollywood domination, few film industries proved competitive. The Italian industry, which had pioneered the feature film with spectacular films like 'Quo vadis?' (1913) and 'Cabiria' (1914), almost collapsed. In Scandinavia, the Swedish cinema had a brief period of glory, notably with powerful epic films and comedies. Even the French cinema found itself in a difficult position. In Europe, only Germany proved industrially capable, while in the new Soviet Union and in Japan, the development of the cinema took place in conditions of commercial isolation.</p>
      <p>Hollywood took the lead artistically as well as industrially. Hollywood films appealed because they had better-constructed narratives, their special effects were more impressive, and the star system added a new dimension to screen acting. If Hollywood did not have enough of its own resources, it had a great deal of money to buy up artists and technical innovations from Europe to ensure its continued dominance over present or future competition.</p>
      <p>The rest of the world survived partly by learning from Hollywood and partly because audiences continued to exist for a product which corresponded to needs which Hollywood could not supply. As well as popular audiences, there were also increasing audiences for films which were artistically more adventurous or which dealt with wider international issues.</p>
      `
    },
    'answer': {
      'type': 'checkboxes',
      'question': 'Questions 17 – 18',
      'number': 2,
      'description': 'Choose <b>TWO</b> correct answers.',
      'title': '',
      'content': [
        {
          'id': 17,
          'question': `<strong>17 – 18</strong>&nbsp;&nbsp;&nbsp; Which <strong>TWO</strong> possible reasons for American dominance of the film industry are given in the text?`,
          'answers': [
            {'id': 1, 'content': "plenty of capital to purchase what it didn't have"},
            {'id': 2, 'content': 'making films dealing with serious issues'},
            {'id': 3, 'content': 'being first to produce a feature film'},
            {'id': 4, 'content': 'well-written narratives'},
            {'id': 5, 'content': 'the effect of the First World War'}
          ]
        }
      ]
    }
  },
  {
    'page': 5,
    'title': `<h4>Part 1</h4>
    <p>Read the text below and answer questions <b>19</b> – <b>23</b>.</p>`,
    'question': {
     'title': 'Political units in the history of West Africa',
     'content': `<p style="margin: 25px 0;"><i style="font-size:16px;font-weight:520">Note: this is an extract from a General Training Reading text on the subject of political units in the history of West Africa</i></p>
     <p>Ife, perched at the edge of Nigeria's forest, is thought to have come to prominence through its control of local products – including ivory, gold and pepper – in external trade. By AD 1300, its walled capital was at the peak of its wealth, with many shrines featuring elaborate pavements made of pieces of pottery, and a rich tradition of creating brass and terracotta sculptures, including ones of people richly adorned in ceremonial regalia. Many of these have survived. Subsistence for the large elite and artisan population appears to have been based upon small livestock and the cultivation of vegetables. Around AD 1500, the city of Ife declined, and the region's center of power shifted to Benin without any appreciable break in cultural tradition.</p>
     `
    },
   'answer': {
     'type': 'inputTexts in one paragraph',
     'question': 'Questions 19 – 23',
     'number': 5,
     'description': 'Complete the summary. Write <b>ONE WORD ONLY</b> from the text in each gap.',
     'title': 'Ife',
     'className': 'input-with-paragraph',
     'content': [
       {
         'id': 19,
         'answers': [
           'The state of Ife adjoined the ',
           'in Nigeria, and traded a variety of goods, including metals such as '
         ]
       },
       {
         'id': 20,
         'answers': [
           ' ',
           '. Floors in religious buildings were made from bits of '
         ]
       },
       {
         'id': 21,
         'answers': [
           ' ',
           '. There are many surviving examples of  '
         ]
       },
       {
         'id': 22,
         'answers': [
           ' ',
           ' made of brass or terracotta. The population lived on animal products, and crops such as  '
         ]
        },
       {
         'id': 23,
         'answers': [
           ' ',
           '.'
         ]
       }
      ]
    }
  },
  {
    'page': 6,
    'title': `<h4>Part 2</h4>
    <p>Read the text below and answer questions <b>24</b> – <b>28</b>.</p>`,
    'question': {
      'title': '',
      'content': `<h1 style="font-size:24px">ACCIDENT INSURANCE FOR CITY MEDIA EMPLOYEES</h1>
      <p>City Media is pleased to offer its employees accident insurance benefits which are unique in the industry. Our insurance package not only insures employees against accidents occurring on the job, but extends to their off-hours. It also provides 24-hour protection to dependants and to eligible partners. A general description of the accident insurance package is shown below. Any questions regarding it may be referred to our Human Resources Department.</p>
      <p>Our basic insurance is the same for all employees, and City Media makes enrolling in this program a condition of employment. We make an exception for those who have the same or greater coverage in an alternate plan. However, employees with other plans are still able to have adult dependants enrolled in ours. At this time, City Media does not extend this insurance to temporary staff, whether they are under contract for their services or not.</p>
      <p>Further, employees can usually purchase accident insurance for their partners. However, submission and review of an application to the insurance company will determine whether the partner is eligible to participate.The terms in these policies bought for spouses are identical to those in the employees’ policy. This is, of course, provided that he/she has no accident insurance under another plan.</p>
      <p>Accident benefits take effect after completing three months of employment. Full-time employees will then automatically receive the minimum $80,000 worth of protection. Part-time employees, defined as those scheduled to work less than forty hours per week, will also be offered accident protection, but the amount of this coverage depends on the hours they typically work. Additional insurance is optional and is sold in amounts of $25,000 and capped at $100,000. Anyone who is interested can submit a request to purchase it and will be responsible for the premium as well as the fees to administer it.</p>
      <p>If employees take an extended time off work on leave, they can either decide not to carry accident insurance or they can decide to keep it and pay 100% of the expense. Basic insurance protection resumes on the first day of the return to work; however, the optional coverages that are discontinued during this time are not automatically restored. These coverages will resume after a medical, a letter from the doctor, and an assurance that the insurance carrier is satisfied.</p>
      `
    },
    'answer': {
      'type': 'inputTexts in paragraphs',
      'question': 'Questions 24 – 28',
      'number': 5,
      'description': 'Complete the sentences. Write <b>ONE WORD ONLY</b> from the text in each gap.',
      'title': '',
      'className': 'without-bullets-points',
      'content': [
        {
          'id': 24,
          'answers': [
            'The accident protection at City Media is ',
            ' amongst similar companies.'
          ]
        },
        {
          'id': 25,
          'answers': [
            'The insurance programme excludes ',
            ' employees.'
          ]
        },
        {
          'id': 26,
          'answers': [
            'An employee’s partner is not automatically ',
            ' for the insurance.'
          ]
        },
        {
          'id': 27,
          'answers': [
            'The insurance coverage for part-timers is related to their usual number of ',
            '.'
          ]
        },
        {
          'id': 28,
          'answers': [
            'Employees can send in a ',
            ' for extra insurance.'
          ]
        }
      ]
    }
  },
  {
    'page': 7,
    'title': `<h4>Part 2</h4>
    <p>Read the text below and answer questions <b>29</b> – <b>34</b>.</p>`,
    'question': {
      'title': '',
      'content': `<h1 style="font-size:24px">CITY MEDIA INTERNSHIPS</h1>
      <p>We are a proudly Canadian organization offering six annual internships, valued at $10,000 each, to deserving persons from minority groups. We offer career assistance, and an opportunity for these individuals to demonstrate the talent they have and get hands-on experience in broadcasting. We hope that our commitment to these groups becomes an industry-wide model of acceptance. Our goal is to have the City Media family mirror the diversity that makes our nation strong.</p>
      <p>The internship winners will work at one of our two speciality TV stations. The Connect station provides programming on regional events, while the emphasis at Transview is on instructional shows. Each intern will work in an entry-level position within an area that meets the requirements of the company and be paid at the opening rate set by the company for that position. If the assignment makes relocation necessary, a maximum $1,500 grant is provided to assist with these expenses.</p>
      <p>Interested broadcasting applicants should provide evidence of full-time enrolment in the field of broadcasting at an accredited post-secondary institution. An official transcript from the educational institution is also required. Mature students may replace this transcript with a one-page typewritten statement of their goals. References from three teachers or employers will be necessary if the application proceeds.</p>
      <p>Once your application is accepted, you will receive a confirmation letter by mail from Personnel. The application is then referred to a Canada-wide panel of City Media employees. These individuals are familiar with the positions that would be considered a complementary fit with your stated career path. They will put together a shortlist of promising candidates and conduct an in-person or telephone interview. The type of interview will vary with the distance of each candidate. The hiring decisions of the panel are final.</p>
      <p>If a candidate is not eligible, the application will be removed from the competition, as will those whose applications and accompanying documents are received later than the deadline for submission. No exceptions can be made for delayed, lost or misdirected mail.</p>
      `
    },
    'answer': {
      'type': 'inputTexts in one ul',
      'question': 'Questions 29 – 34',
      'number': 6,
      'description': 'Complete the notes. Write <b>ONE WORD ONLY</b> from the text in each gap.',
      'title': 'CITY MEDIA INTERNSHIPS',
      'className': 'inputTexts-in-one-ul',
      'content': [
        {
          'id': 29,
          'answers': [
            '<p>&#8226; Internships:</p><br/> <p>&nbsp;&nbsp;&nbsp;- allow minorities to gain&nbsp;&nbsp;</p>',
            '<p>&nbsp;and show their talents</p>'
          ]
        },
        {
          'id': 30,
          'answers': [
            '<p>&nbsp;&nbsp;&nbsp;- further City Media’s aim to reflect the&nbsp;&nbsp; </p>',
            '<p>&nbsp;of people in Canada</p><br/><p>&#8226; Internship at Transview focuses on educational broadcasting.</p>'
          ]
        },
        {
          'id': 31,
          'answers': [
            '<p>&#8226; An additional amount of money is given if&nbsp;&nbsp;</p> ',
            '<p>&nbsp;is required.</p>'
          ]
        },
        {
          'id': 32,
          'answers': [
            '<p>&#8226; Support application with:</p><br/> <p>&nbsp;&nbsp;&nbsp;- proof of present&nbsp;&nbsp; </p>',
            '<p>&nbsp;in broadcasting studies</p>'
          ]
        },
        {
          'id': 33,
          'answers': [
            '<p>&nbsp;&nbsp;&nbsp;- a&nbsp;&nbsp; </p>',
            '<p>&nbsp;issued by your school</p><br/> <p>&#8226; A panel decides which jobs are a good fit for each intern.</p>'
          ]
        },
        {
          'id': 34,
          'answers': [
            '<p>&#8226; Interview method depends on&nbsp;&nbsp; </p>',
            '<p>&nbsp;.</p><br/> <p>&#8226; Company strict about the deadline stated for applications.</p>'
          ]
        }
      ]
    }
  }
];
